// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c628ca8d","453":"0ad7d985","732":"1f64cb24","977":"79d5b26c"}[chunkId] + ".chunk.js";
};